import { render, staticRenderFns } from "./CourseFormAndExamCard.vue?vue&type=template&id=6cd9f939&scoped=true"
import script from "./CourseFormAndExamCard.vue?vue&type=script&lang=js"
export * from "./CourseFormAndExamCard.vue?vue&type=script&lang=js"
import style0 from "./CourseFormAndExamCard.vue?vue&type=style&index=0&id=6cd9f939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd9f939",
  null
  
)

export default component.exports